import { Suspense } from 'react';

import { Box, Group, Stack, Text } from '@mantine/core';

import * as Sentry from '@sentry/react';
import { useTranslation } from 'react-i18next';

import { Error } from '../../../../../shared/components/UI/Error/Error';
import { Loader } from '../../../../../shared/components/UI/Loader/Loader';

import IconWandAi from '../../../../../shared/assets/ai_icons/wand.svg?react';
import { AssistantHistory } from './AssistantHistory';

export default function AssistantPageLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Stack
      p="05"
      spacing="02"
      style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}
    >
      {children}
    </Stack>
  );
}

function AssistantPageLayoutContent({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Stack
      sx={{
        width: '100%',
        maxWidth: 1280,
        margin: 'auto',
        overflowY: 'auto',
        flex: 1,
      }}
    >
      <Sentry.ErrorBoundary fallback={<Error />}>
        <Suspense fallback={<Loader />}>{children}</Suspense>
      </Sentry.ErrorBoundary>
    </Stack>
  );
}

interface LayoutTitleProps {
  label?: string;
}

function LayoutTitle({ label }: LayoutTitleProps) {
  const { t } = useTranslation('bidResponse');

  return (
    <Group spacing="02" position="apart" align="center" noWrap>
      <Group spacing="01" noWrap>
        <IconWandAi />
        <Text size="md" c="gray.9">
          {t('assistant.title')}
        </Text>
        {!!label && (
          <>
            <Box bg={'gray.4'} h={4} w={4} style={{ borderRadius: '100%' }} />
            <Text size="sm" c="gray.6">
              {label}
            </Text>
          </>
        )}
      </Group>
      <AssistantHistory />
    </Group>
  );
}

AssistantPageLayout.Title = LayoutTitle;
AssistantPageLayout.Content = AssistantPageLayoutContent;
